import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
var css = {
  "subSectionContainer": "oalp-3ZLUT",
  "collapsible": "oalp-20fuL",
  "showMore": "oalp-2rJfp",
  "collapsed": "oalp-2APYD",
  "collapsedContent": "oalp-2jXDt",
  "cities": "oalp-2o4Vh",
  "collapsedTitle": "oalp-2pbHh"
};
import classNames from 'classnames';
export var SubSection = function SubSection(_ref) {
  var title = _ref.title,
    contentTitle = _ref.contentTitle,
    content = _ref.content,
    sectionOpenCta = _ref.sectionOpenCta,
    sectionCloseCta = _ref.sectionCloseCta;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isSectionOpened = _useState2[0],
    setIsSectionOpened = _useState2[1];
  var toggleSection = function toggleSection() {
    setIsSectionOpened(!isSectionOpened);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: css.subSectionContainer,
    onClick: toggleSection
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(css.collapsible, _defineProperty({}, css.collapsed, isSectionOpened))
  }, /*#__PURE__*/React.createElement("span", null, title), !isSectionOpened && /*#__PURE__*/React.createElement("span", {
    className: css.showMore
  }, sectionOpenCta), isSectionOpened && /*#__PURE__*/React.createElement("div", {
    className: css.collapsedContent
  }, /*#__PURE__*/React.createElement("div", {
    className: css.cities
  }, /*#__PURE__*/React.createElement("div", {
    className: css.collapsedTitle
  }, contentTitle), /*#__PURE__*/React.createElement("div", {
    className: css.collapsedContent
  }, content)), /*#__PURE__*/React.createElement("div", {
    className: css.showMore
  }, sectionCloseCta))));
};
export default SubSection;